import { Routes } from '@angular/router';

import { AuthGuard } from '@core/guards/auth.guard';
import { NoAuthGuard } from '@core/guards/no-auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'authenticated',
    loadChildren: () =>
      import('./pages/authenticated/authenticated.module').then((m) => m.AuthenticatedModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'public/applications',
    loadComponent: () =>
      import('./pages/public/application-form/public-application-form.page').then(
        (m) => m.PublicApplicationFormPage
      ),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  { path: '**', redirectTo: '/not-found' },
];
